module.exports = __webpack_public_path__ + "static/JS-logo-d5cdfab0bec790f3e69ca95930cfa7b5.png";